import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useSelector, useDispatch } from 'react-redux';
import { setCopyTemplate } from '../store/reducers/saveGuids';
import Network from './Requests';
import { useTranslation } from "react-i18next";

const CopyTemplate = () => {
  const dispatch = useDispatch();
  const copy = useSelector((state) => state.guids.copyTemplate);
  const projectGuid = useSelector((state) => state.variant?.current?.projectGuid);
  const { t } = useTranslation();

  const saveTemplate = async () => {
    const send = await new Network().CopyProjectToCatalog(projectGuid);
    if (send) dispatch(setCopyTemplate(!copy));
  };

  const close = () => {
    dispatch(setCopyTemplate(!copy));
  };

  return (
    <Dialog
      open={copy}
      onClose={() => dispatch(setCopyTemplate(!copy))}
    >
      <DialogContent className="public-link">
        <div className="infoList--title">{ t("copyTemplate.title") }</div>
        <div className="share">
          <div className="form--row">
            <div className="hint-info">
              { t("copyTemplate.confirm") }
            </div>
          </div>
          <div className="buttons-menu center">
            <button onClick={saveTemplate}>{ t("yes") }</button>
            <button onClick={close}>{ t("no") }</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CopyTemplate;
